"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOrElseForResult = void 0;
/**
 *  Maps a `Result<T, E>` to `U` by applying _transformer_ to a contained `Ok(T)` value in _input_,
 *  or a _recoverer_ function to a contained `Err(E)` value in _input_.
 *  This function can be used to unpack a successful result while handling an error.
 */
function mapOrElseForResult(input, recoverer, transformer) {
    if (input.ok) {
        var result = transformer(input.val);
        return result;
    }
    var fallback = recoverer(input.err);
    return fallback;
}
exports.mapOrElseForResult = mapOrElseForResult;
